To continue using the Sympheny web app, you must accept the General Terms &
Conditions (GTC).
<a target="_blank" href="https://www.sympheny.com/gtc">English version</a> |
<a target="_blank" href="https://www.sympheny.com/agb">German version</a>
<button color="primary" mat-raised-button (click)="acceptGTC()">
  I accept the GTC
</button>
